import React, { useState, useEffect } from "react";
import { FilterButton } from "../../../../components/E-check/style";
import { CreditCardModal } from "./modalCreditCard";
import { useAccount } from "../../../../hooks/useAccount";
import { getImage } from "../../../../services/getAssets";
import { TransactionType } from "../../../../services/enums";
import { useAuth } from "../../../../hooks/useAuth";
import { ModalMfa } from "./modalMfa";
import { apiV1 } from "../../../../lib/axios";
import { toast } from "react-toastify";
import moment from "moment";
import bankList from '../../../../services/bankList.json';
import svgElo from '../../../../assets/image/ELO.svg';
import svgVisa from '../../../../assets/image/Visa.svg';
import svgMaster from '../../../../assets/image/Master.svg';
import svgHiper from '../../../../assets/image/Hipercard.svg';
import { VoucherModal } from "./voucherModal";
import { DeleteOutlined } from "@ant-design/icons";
import { CardDelectionModal } from "./cardDelectionModal";
import { PaymentWarnings } from "./PaymentWarnings";

export const PaymentSection = ({ setShowToast, modo, setModo, parcelas, setParcelas, payTicket, payTicketWithCreditCard, listCards, createCard, boleto, cardsData, deactivateCard }) => {

  const { avaliableBalance, getBalance } = useAccount();
  const { user, getProfile } = useAuth();
  const [paymentUsage, setPaymentUsage] = useState({});
  const [mfaModal, setMfaModal] = useState();
  const [selectedCardId, setSelectedCardId] = useState();
  const [paymentLoader, setPaymentLoader] = useState(false);
  const [isVoucherButtonDisabled, setIsVoucherButtonDisabled] = useState(false);
  const [modalVoucher, setModalVoucher] = useState(false);
  const [cardDelectionModal, setCardDelectionModal] = useState(false);

  useEffect(() => {
    const fetchBalance = async () => {
      if (!avaliableBalance) {
        await getBalance();
      }
    };
    fetchBalance();
  }, []);

  const getBrandLogo = (brand) => {
    if (!brand) return defaultLogo;
    const name = brand.toLowerCase();

    if (name.includes("visa")) return svgVisa;
    if (name.includes("master")) return svgMaster;
    if (name.includes("elo")) return svgElo;
    if (name.includes("hiper")) return svgHiper;

    return defaultLogo;
  };

  useEffect(() => {
    if (!user.id) {
      getProfile();
    }
    if (user?.accountTransactionUsages?.PAYMENT) {
      const { used, free, remaining, tax } = user.accountTransactionUsages.PAYMENT;
      setPaymentUsage({ used, free, remaining, tax });
    }
  }, [user, getProfile]);

  const [creditCardModal, setCreditCardModal] = useState(false);

  const monthly_fee = 0.035;

  const parcelPrice = (principal, n, i) => {
    if (n === 1) {
      const total = principal * (1 + i);
      return total;
    }

    const f = Math.pow(1 + i, n);
    const res = principal * ((i * f) / (f - 1));

    if (isNaN(res)) return "-";
    return res;
  };


  const getBankName = (bankCode) => {
    const bank = bankList.find((item) => item.code == bankCode);
    return bank ? bank.name : '';
  };

  const calculateParcel = (n) => parcelPrice(boleto?.totalValue, n, monthly_fee);

  function validateType(barCode) {
    const clean = barCode.replace(/\D/g, "");
    if (clean.length !== 44) return false;

    if (!clean.startsWith("8")) return false;
    return true;
  }
  const isValid = boleto?.barcode && avaliableBalance >= boleto?.totalValue ? true : false;
  const isValidType = boleto?.barcode ? validateType(boleto.barcode) : false;

  const generateVoucher = async (data) => {
    try {
      const response = await apiV1.post('/voucher/generate', data);
      const res = response.data.data;
      localStorage.removeItem('comprovante');
      localStorage.setItem('comprovante', res.base64);
    } catch (error) {
      console.error('Erro ao gerar comprovante:', error);
      throw error;
    }
  };

  const handleChangePaymentMethod = (paymentMethod) => {
    if (paymentMethod === 'cartao') {
      setSelectedCardId(cardsData[0]?.id);
      setModo('cartao');
    } else {
      setModo('saldo');
    }
  };


  const generatePaymentData = (otp) => {
    const currentDateTime = moment().tz('America/Sao_Paulo').toISOString();
    const payerBank = `${user.account.bank} - ${getBankName(user.account.bank)}`;

    return {
      dueDate: currentDateTime,
      type: TransactionType.PreDebitBoletoOut,
      receiverName: boleto.beneficiaryName,
      receiverTaxNumber: boleto.taxNumberBeneficiary,
      payerName: user.name,
      payerTaxNumber: user.taxNumber,
      payerBank: payerBank,
      payerBankBranch: user.account.bankBranch || "Não informado",
      payerBankAccount: user.account.bankAccount || "Não informado",
      payerBankAccountDigit: user.account.bankAccountDigit || "Não informado",
      identifier: boleto.identifier,
      value: parseFloat(boleto.updatedValue || boleto.totalValue),
      barCode: boleto.barcode,
      url_logo: getImage('logo-preto.png'),
      otp,
      transferDate: currentDateTime,
    };
  };


  const handleConfirmPayment = async (otp) => {
    let transactionId;
    const paymentData = generatePaymentData(otp);

    try {
      if (modo === 'saldo') {
        const paymentResponse = await payTicket({
          barCode: paymentData.barCode,
          dueDate: paymentData.dueDate,
          value: paymentData.value,
          receiverName: paymentData.receiverName,
          receiverTaxNumber: paymentData.receiverTaxNumber,
          otp: paymentData.otp,
        });
        transactionId = paymentResponse.id;
      } else {
        const paymentResponse = await payTicketWithCreditCard({
          ticket: paymentData,
          otp: paymentData.otp,
          cardId: selectedCardId,
          appliedFee: parcelas > 1 ? (Math.pow(1 + monthly_fee, parcelas) - 1) : monthly_fee,
          installments: String(parcelas),
          amount: (parcelPrice(boleto.totalValue, parcelas, monthly_fee)) * parcelas,
        });

        transactionId = paymentResponse.id;
      }
      setModalVoucher(true);
      setMfaModal(false);
    } catch (err) {
      console.error("Erro ao pagar:", err);
      const backendMsg = err?.response?.data?.message;
      if (backendMsg) {
        toast.error(backendMsg);
      }
      return;
    }

    try {
      await generateVoucher({ ...paymentData, transactionId });
    } catch (err) {
      toast.success('Pagamento realizado, porém não foi possível gerar o comprovante.');
      console.error("Erro ao gerar comprovante:", err);
      localStorage.removeItem('comprovante');
      setIsVoucherButtonDisabled(true);
    }
  };

  const handleBoletoConfirmation = async (otp) => {
    setPaymentLoader(true);
    if (!otp) {
      setPaymentLoader(false);
      return toast.error('Insira o código de confirmação recebido por SMS.');
    }
    await handleConfirmPayment(otp);
    setPaymentLoader(false);
  };


  const brl = (n) =>
    n.toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

  const [valorParcela, setValorParcela] = useState(brl(calculateParcel(12)));

  useEffect(() => {
    setValorParcela(brl(calculateParcel(parcelas)));
  }, [parcelas]);

  return (

    <>
      <section
        className="boleto-section text-black" // aplica texto preto em todos os elementos filhos
        style={{ marginTop: "1rem" }}
      >
        <h3 className="text-base font-semibold mb-3">Como deseja pagar</h3>
        <div
          style={{
            display: "flex",
            gap: "1rem",
            flexWrap: "wrap", // permite quebrar em linha se for tela pequena
            justifyContent: "space-between", // espaça bem os itens
            marginTop: "1rem",
          }}
        >
          {/* Botão Saldo */}
          <div
            onClick={() => { if (isValid) handleChangePaymentMethod('saldo'); }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              padding: "1rem",
              borderRadius: "1rem",
              border:
                modo === "saldo"
                  ? "2px solid rgba(16, 185, 129, 0.2)"
                  : "2px solid transparent",
              backgroundColor: modo === "saldo" ? "#ECFDF5" : "#F8FAFC",
              cursor: "pointer",
              cursor: isValid ? "pointer" : "not-allowed",
              opacity: isValid ? 1 : 0.5,
              transition: "all 0.2s ease",
              flex: "1 1 48%", // mantém eles lado a lado ocupando metade do espaço cada
              minWidth: "300px",
              boxSizing: "border-box",
            }}
          >
            {/* Ícone à esquerda */}
            <span
              style={{
                width: "3rem",
                height: "2.5rem",
                borderRadius: "0.75rem",
                backgroundColor: "#10B981",
                color: "#FFF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.5rem",
                flexShrink: 0,
              }}
            >
              💵
            </span>

            {/* Textos à direita do ícone */}
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <span
                style={{ fontSize: "0.875rem", fontWeight: 600, color: "#000" }}
              >
                Pagar à vista com saldo
              </span>
              <span style={{ fontSize: "0.875rem", color: "#000" }}>
                Sem juros, quitação imediata
              </span>
            </span>
          </div>

          {/* Botão Cartão */}
          <div
            onClick={() => {
              if (isValidType) handleChangePaymentMethod("cartao");
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "1rem",
              padding: "1rem",
              borderRadius: "1rem",
              border:
                modo === "cartao"
                  ? "2px solid rgba(16, 185, 129, 0.2)"
                  : "2px solid transparent",
              backgroundColor: modo === "cartao" ? "#ECFDF5" : "#F8FAFC",
              cursor: isValidType ? "pointer" : "not-allowed",
              opacity: isValidType ? 1 : 0.5,
              transition: "all 0.2s ease",
              flex: "1 1 48%",
              minWidth: "300px",
              boxSizing: "border-box",
            }}
          >
            <span
              style={{
                width: "3rem",
                height: "2.5rem",
                borderRadius: "0.75rem",
                backgroundColor: "#1E293B",
                color: "#FFF",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "1.5rem",
                flexShrink: 0,
              }}
            >
              💳
            </span>
            <span
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <span
                style={{ fontSize: "0.875rem", fontWeight: 600, color: "#000" }}
              >
                Parcelar no cartão de crédito
              </span>
              <span style={{ fontSize: "0.875rem", color: "#000" }}>
                {isValidType
                  ? "Parcele até 12x — parcelas que cabem no seu bolso"
                  : "Indisponível para este tipo de boleto"}
              </span>
            </span>
          </div>
        </div>


        {modo === "saldo" && (
          <div className="mt-5 space-y-4 text-black">
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                gap: "1rem",
                marginTop: "1rem",
              }}
            >
              {/* Card: Saldo disponível */}
              <div
                style={{
                  flex: 1,
                  padding: "1rem",
                  borderRadius: "1rem",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.08)",
                  border: "1px solid #E2E8F0", // borda leve
                  transition: "all 0.2s ease",
                }}
              >
                <div style={{ fontSize: "0.875rem", color: "#475569" }}>Saldo disponível</div>
                <div style={{ fontSize: "1.25rem", fontWeight: 600, color: "#000" }}>
                  {avaliableBalance
                    ?
                    brl(avaliableBalance)
                    :
                    "Carregando..."
                  }
                </div>
              </div>

              {/* Card: Valor a pagar */}
              <div
                style={{
                  flex: 1,
                  padding: "1rem",
                  borderRadius: "1rem",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.08)",
                  border: "1px solid #E2E8F0",
                  transition: "all 0.2s ease",
                }}
              >
                <div style={{ fontSize: "0.875rem", color: "#475569" }}>Valor a pagar</div>
                <div style={{ fontSize: "1.25rem", fontWeight: 600, color: "#000" }}>
                  {boleto?.totalValue ? brl(boleto.totalValue) : "-"}
                </div>
              </div>

              {/* Card: Saldo após pagamento */}
              <div
                style={{
                  flex: 1,
                  padding: "1rem",
                  borderRadius: "1rem",
                  backgroundColor: "#ffffff",
                  boxShadow: "0 4px 10px rgba(0, 0, 0, 0.08)",
                  border: "1px solid #E2E8F0",
                  transition: "all 0.2s ease",
                }}
              >
                <div style={{ fontSize: "0.875rem", color: "#475569" }}>
                  Saldo após pagamento
                </div>
                <div style={{ fontSize: "1.25rem", fontWeight: 600, color: "#000" }}>
                  {avaliableBalance && boleto?.totalValue ?
                    brl(avaliableBalance - boleto.totalValue)
                    :
                    "-"
                  }
                </div>
              </div>
            </div>

            <p className="text-sm" style={{ marginTop: "4rem" }}>
              Pagamento instantâneo via saldo X-Pay. Seu boleto será quitado em até 5 minutos.
            </p>
            <PaymentWarnings dueDate={boleto?.dueDate} />
            {isValid ?


            <FilterButton
              style={{
                marginBottom: "1rem",
              }}
              onClick={() => setMfaModal(true)}
            >
              Confirmar pagamento à vista
            </FilterButton>
            :
            <FilterButton
              style={{
                marginBottom: "1rem",
                backgroundColor: "#E2E8F0",
                color: "#475569",
                cursor: "not-allowed",
              }}
              disabled
            >
              Confirmar pagamento à vista
            </FilterButton>
            }
          </div>
        )}

        {modo === "cartao" && (
          <div className="mt-2 space-y-5 text-black">
            {/* Simulador de Parcelas */}
            <section className="p-4 rounded-2xl bg-slate-50 space-y-4">
              <h4 className="font-semibold">Simulador de Parcelas</h4>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "stretch",
                  gap: "1rem",
                  marginTop: "1rem",
                }}
              >
                {/* Card: Valor original */}
                <div
                  style={{
                    flex: 1,
                    padding: "1rem",
                    borderRadius: "0.75rem",
                    backgroundColor: "#ffffff",
                    border: "1px solid #E2E8F0", // borda leve
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)", // efeito modal
                    transition: "all 0.2s ease",
                  }}
                >
                  <div style={{ fontSize: "0.875rem", color: "#475569" }}>Valor original</div>
                  <div style={{ fontSize: "1.125rem", fontWeight: 600, color: "#000" }}>
                    {brl(boleto?.totalValue)}
                  </div>
                </div>

                {/* Card: Parcela */}
                <div
                  style={{
                    flex: 1,
                    padding: "1rem",
                    borderRadius: "0.75rem",
                    backgroundColor: "#ffffff",
                    border: "1px solid #E2E8F0",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.08)",
                    transition: "all 0.2s ease",
                  }}
                >
                  <div style={{ fontSize: "0.875rem", color: "#475569" }}>Parcela</div>
                  <div style={{ fontSize: "1.125rem", fontWeight: 600, color: "#000" }}>
                    {valorParcela}
                  </div>
                </div>
              </div>


              <div
                style={{ borderRadius: "16px" }}
                className="mt-2 overflow-hidden rounded-2xl border border-slate-200"
              >
                <table className="min-w-full text-sm">
                  <thead className="bg-slate-50 text-black">
                    <tr>
                      <th className="text-left p-3">Parcelas</th>
                      <th className="text-left p-3">Valor da parcela</th>
                    </tr>
                  </thead>
                  <tbody>
                    {Array.from({ length: 12 }, (_, i) => i + 1).map((p) => {
                      const isSelected = parcelas === p
                      return (
                        <tr
                          key={p}
                          onClick={() => setParcelas(p)}
                          className={`border-t cursor-pointer transition-all duration-300 transform
              ${isSelected
                              ? "bg-emerald-50 text-emerald-700 font-semibold border-1 border-emerald-500 rounded-xl shadow-lg shadow-emerald-100 scale-[1.03]"
                              : "border-slate-200 hover:scale-[1.01] hover:shadow-md hover:shadow-slate-100"
                            }`}
                          style={{
                            cursor: "pointer",
                            transformOrigin: "center",
                            boxShadow: isSelected
                              ? "0 6px 12px rgba(16, 185, 129, 0.25)"
                              : "none",
                          }}
                        >
                          <td className="p-3">{p}x</td>
                          <td className="p-3">{brl(calculateParcel(p))}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
            </section>

            <section style={{ borderRadius: "16px" }} className="p-4 rounded-2xl border border-slate-200 space-y-4">
              <h4 className="font-semibold">Cartão de crédito</h4>
              <div style={{ marginTop: "1rem" }}>
                {cardsData && cardsData.length > 0 ? (
                  cardsData.map((card) => {
                    const isSelected = selectedCardId === card.id;

                    return (
                      <div
                        key={card.id}
                        onClick={() => setSelectedCardId(card.id)}
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          alignItems: "center",
                          justifyContent: "flex-start",
                          gap: "12px",
                          padding: "12px",
                          marginBottom: "8px",
                          borderRadius: "10px",
                          border: isSelected ? "2px solid #3b82f6" : "1px solid #e5e7eb",
                          backgroundColor: "white",
                          boxShadow: isSelected
                            ? "0 2px 8px rgba(59, 130, 246, 0.3)"
                            : "0 1px 4px rgba(0,0,0,0.05)",
                          cursor: "pointer",
                          transition: "all 0.2s ease-in-out",
                        }}
                        onMouseEnter={(e) => {
                          if (!isSelected)
                            e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.1)";
                        }}
                        onMouseLeave={(e) => {
                          if (!isSelected)
                            e.currentTarget.style.boxShadow =
                              "0 1px 4px rgba(0,0,0,0.05)";
                        }}
                      >
                        {/* Ícone da bandeira */}
                        <div
                          style={{
                            width: "50px",
                            height: "35px",
                            backgroundColor: "#0f172a",
                            padding: "6px",
                            borderRadius: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <img
                            src={getBrandLogo(card.brand)}
                            alt={card.brand}
                            style={{
                              marginLeft: "1px",
                              maxWidth: "100%",
                              maxHeight: "100%",
                              objectFit: "contain",
                            }}
                          />
                        </div>

                        {/* Informações do cartão */}
                        <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                          <span style={{ fontSize: "15px", fontWeight: 500, color: "#111827" }}>
                            {card.brand || "Desconhecido"} •••• {card.lastDigits}
                          </span>
                          <span style={{ fontSize: "12px", color: "#6b7280", marginTop: "2px" }}>
                            Válido até {card.expiryDate || "--/--"}
                          </span>
                        </div>
                        <DeleteOutlined
                          size={20}
                          color="#dc2626"
                          style={{ cursor: "pointer", marginLeft: "10px" }}
                          title="Remover cartão"
                          className="inline-block cursor-pointer hover:text-red-700 transition"
                          onClick={(e) => {
                            e.stopPropagation(); // impede o clique de acionar o onClick da div
                            setSelectedCardId(card.id);
                            setCardDelectionModal(true);
                          }}
                        />


                      </div>
                    );
                  })
                ) : (
                  <div
                    style={{
                      textAlign: "center",
                      color: "#6b7280",
                      fontSize: "14px",
                      padding: "16px",
                      border: "1px solid #e5e7eb",
                      borderRadius: "8px",
                      backgroundColor: "#f9fafb",
                    }}
                  >
                    Nenhum cartão encontrado, adicione um cartão de crédito.
                  </div>
                )}
              </div>
              
              <PaymentWarnings dueDate={boleto?.dueDate} />

              <div
                style={{
                  display: "flex",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  gap: "1rem", // espaçamento entre os botões
                  marginTop: "1rem",
                }}
              >
                <FilterButton disabled={!selectedCardId || !boleto?.barcode} onClick={() => setMfaModal(true)}>
                  Confirmar pagamento parcelado
                </FilterButton>

                <button
                  onClick={() => setCreditCardModal(true)}
                  type="button"
                  style={{
                    borderRadius: "12px",
                    color: "black",
                    border: "1px solid black",
                    padding: "8px 16px",
                    fontSize: "14px",
                    fontWeight: "bold",
                    cursor: "pointer",
                    backgroundColor: "white",
                    transition: "all 0.2s ease",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.backgroundColor = "#f1f5f9";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.backgroundColor = "white";
                  }}
                >
                  Adicionar
                </button>
              </div>
            </section>
          </div>
        )}
      </section>

      <CardDelectionModal modalDeletion={cardDelectionModal} setModalDeletion={setCardDelectionModal} handleDeletion={deactivateCard} cardId={selectedCardId} listCards={listCards} />
      <ModalMfa handlePaymentConfirmation={handleBoletoConfirmation} data={boleto} modalMfa={mfaModal} setModalMfa={setMfaModal} paymentLoader={paymentLoader} setModalVoucher={setModalVoucher} />
      <VoucherModal boleto={boleto} setModalVoucher={setModalVoucher} modalVoucher={modalVoucher} user={user} isVoucherButtonDisabled={isVoucherButtonDisabled} />
      <CreditCardModal
        creditCardModal={creditCardModal}
        setCreditCardModal={setCreditCardModal}
        createCard={createCard}
        listCards={listCards}
      />
    </>
  );
};